import { render, staticRenderFns } from "./RejectBookingAction.vue?vue&type=template&id=312c6c3f&"
import script from "./RejectBookingAction.vue?vue&type=script&lang=js&"
export * from "./RejectBookingAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports